const { Core, Utils, Events } = Global;
const { $fetch, $loading } = Utils;

customElements.define('collection-provider', class extends Core {

    elements = {
        $: [['collection-form'], 'loader']
    }

    propTypes = {
        'collection-url': String
    }

    render() {
        this._getForms();
        this.sub(Events.COLLECTION_CHANGE, this._handleChange);
        this._pageCache = new Map();
        this._maxCacheEntries = 8;
        this._initCache();
    }

    _getForms() {
        this.$forms = new Map();
        this.$('collection-form').map((form) => {
            this.$forms.set(form.id, form);
        });
    }
    
    async _handleChange({ src, url, formId }) {
        this.src = src;
        this._getUrlParams(url, formId);
        await this._getDoc();
        this._updateHistory();
        this.pub(Events.COLLECTION_UPDATED, { src, doc: this.$doc });
    }

    set src(value) {
        const inert = (value === 'dynamic-pagination');
        this.withLoading = !inert;
        if(!inert) {
            this._scrollToTop();
        }
    }

    _initCache() {
        const firstFormId = this.$forms.keys().next().value;
        const initialKey = new URLSearchParams(this._formData(firstFormId)).toString();
        this._setCachedDoc(initialKey, document.documentElement.outerHTML);
    }

    _getUrlParams(url, formId) {
        if(!url && !formId) {
            console.error('collection change does not contain resource');
            return;
        }
        this.urlParams = url
            ? new URL(`${window.location.origin}${url}`).searchParams
            : new URLSearchParams(this._formData(formId));
    }

    _updateHistory() {
        this.urlParams.delete('section_id');
        this.urlParams.delete('page');
        window.history.pushState({}, null, `${window.location.pathname}?${this.urlParams.toString()}`);
    }

    _formData(formId) {
        if(!this.$forms.has(formId)) {
            console.error(`form not found with id ${formId}`);
            return;
        }
        return new FormData(this.$forms.get(formId));
    }

    async _getDoc() {
        const cacheId = this.urlParams.toString();
        const cachedDoc = this._getCachedDoc(cacheId);
        if (cachedDoc) {
            this.$doc = cachedDoc;
            return;
        }

        this.$doc = await this._fetchDoc();
        if (this.$doc?.documentElement) {
            this._setCachedDoc(cacheId, this.$doc.documentElement.outerHTML);
        }
    }

    _getCachedDoc(cacheId) {
        if (!this._pageCache.has(cacheId)) return null;
        const cachedMarkup = this._pageCache.get(cacheId);
        this._pageCache.delete(cacheId);
        this._pageCache.set(cacheId, cachedMarkup);
        return new DOMParser().parseFromString(cachedMarkup, 'text/html');
    }

    _setCachedDoc(cacheId, markup) {
        this._pageCache.set(cacheId, markup);
        if (this._pageCache.size <= this._maxCacheEntries) return;
        const oldestKey = this._pageCache.keys().next().value;
        this._pageCache.delete(oldestKey);
    }

    async _fetchDoc(urlParamsStr) {
        const doc = await $fetch(this.prop('collection-url'), {
            before: this._loading(true),
            after: this._loading(false),
            sectionId: this.sectionId,
            params: this.urlParams
        });
        return doc;
    }

    _loading(state) {
        return () => {
            if(!this.withLoading && state) {
                return;
            }
            $loading(this.$('loader'), state);
        }
    }

    _scrollToTop() {
        window.scrollTo({
            top: this.topPoint + window.pageYOffset,
            behavior: 'smooth',
        });
    }

    get topPoint() {
        const headerHeight = document.documentElement.style.getPropertyValue('--header-height')?.replace('px', '');
        const offset = this.getBoundingClientRect().top;
        return headerHeight ? offset - headerHeight : offset;
    }
})